import React from 'react';
import { queryString } from 'lib/format';

const shareBaseUrl = 'mailto:';

const EmailShare = (props) => {
    const { id, name: subject } = props.content;
    const query = queryString({
        body: `${props.appBaseUrl}?id=${id}`,
        subject
    }, true);
    const shareUrl = `${shareBaseUrl}${query}`;

    return (
        <a
            className="btn-social sm icon-font-before icon-email-solid-before"
            data-route="false"
            href={shareUrl}
        />
    );
};

EmailShare.propTypes = {
    appBaseUrl: React.PropTypes.string,
    content: React.PropTypes.object
};

export default EmailShare;



// WEBPACK FOOTER //
// ./app/social/EmailShare.js